import Image from "next/image";
import copy from "copy-to-clipboard";
import Link from "next/link";

import DarkMode from "../mode/DarkMode";
import Logo from "./../../public/images/logo.png";
import WhiteLogo from "./../../public/images/logo_white.png";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "next/router";
import {
  isChildrenPageActive,
  isParentPageActive,
} from "../../utils/daynamicNavigation";
import { useEffect, useState } from "react";
import WalletButton from "../wallet-btn/WalletButton";
import { useDispatch, useSelector } from "react-redux";
import { setLoginDetails } from "../../redux/counterSlice";
import SearchModal from "../modal/SearchModal";
import SearchInput from "../inputs/SearchInput";
import Tippy from "@tippyjs/react";
import { useTheme } from "next-themes";

import useTranslation from "next-translate/useTranslation";
import setLanguage from "next-translate/setLanguage";

export default function Header01() {
  const { t, lang } = useTranslation("common");
  const languages = [
    {
      language: t("english"),
      key: "en",
    },
    { language: t("spanish"), key: "es" },
    { language: t("chinese"), key: "zh" },
    { language: t("italian"), key: "it" },
    { language: t("french"), key: "fr" },
  ];
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [mobileLangToggle, setMobileLangToggle] = useState(false);
  const [isCollapse, setCollapse] = useState(null);
  const loginDetails = useSelector((state) => state.counter.loginDetails);
  const [WalletDetails, setWalletDetails] = useState({});
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const {theme} = useTheme()

  // window resize
  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024) {
        setToggle(false);
      }
    });
    setWalletDetails(loginDetails);
  }, [loginDetails]);

  // get window size to set header logo size
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const route = useRouter();

  const disConnectWallet = () => {
    dispatch(
      setLoginDetails({
        address: "",
        isLogin: false,
      })
    );
    route.push("/");
  };

  /* -------------------------------------------------------------------------- */
  /*                            daynamic navigations                            */
  /* -------------------------------------------------------------------------- */
  const home = {
    id: 1,
    name: "Home",
    pages: [
      {
        id: uuidv4(),
        name: "Home 1",
        path: "/",
      },
      {
        id: uuidv4(),
        name: "Home 2",
        path: "/home/home_2",
      },
      {
        id: uuidv4(),
        name: "Home 3",
        path: "/home/home_3",
      },
      {
        id: uuidv4(),
        name: "Home 4",
        path: "/home/home_4",
      },
      {
        id: uuidv4(),
        name: "Home 5",
        path: "/home/home_5",
      },
      {
        id: uuidv4(),
        name: "Home 6",
        path: "/home/home_6",
      },
      {
        id: uuidv4(),
        name: "Crypto Consultant",
        condition: true,
        path: "/home/home_7",
      },
      {
        id: uuidv4(),
        name: "NFT Game",
        condition: true,
        path: "/home/home_8",
      },
      {
        id: uuidv4(),
        name: "Dao Platform",
        condition: true,
        path: "/home/home_9",
      },
      {
        id: uuidv4(),
        name: "Crypto App",
        condition: true,
        path: "/home/home_10",
      },
      {
        id: uuidv4(),
        name: "Crypto Trading",
        condition: true,
        path: "/home/home_11",
      },
      {
        id: uuidv4(),
        name: "ICO Landing",
        condition: true,
        path: "/home/home_12",
      },
      {
        id: uuidv4(),
        name: "NFT Aggregator",
        condition: true,
        path: "/home/home_13",
      },
    ],
  };

  const page = {
    id: 2,
    name: "Pages",
    pages: [
      {
        id: uuidv4(),
        name: "Maintenance",
        condition: true,
        path: "/maintenance",
      },
      {
        id: uuidv4(),
        name: "Case Studies",
        condition: true,
        path: "/case-studies",
      },
      {
        id: uuidv4(),
        name: "Single Case Study",
        condition: true,
        path: "/case-studies/case_study_1",
      },
      {
        id: uuidv4(),
        name: "Careers",
        condition: true,
        path: "/careers",
      },
      {
        id: uuidv4(),
        name: "Item Details",
        path: "/item/item_20",
      },
      {
        id: uuidv4(),
        name: "Collections Wide",
        path: "/collections-wide",
        condition: true,
      },
      {
        id: uuidv4(),
        name: "Explore Collections",
        path: "/collection/explore_collection",
      },
      {
        id: uuidv4(),
        name: "Collection",
        path: "/collection/avatar_1",
      },
      {
        id: uuidv4(),
        name: "Rankings",
        path: "/rankings",
      },
      {
        id: uuidv4(),
        name: "User",
        path: "/user/profile",
      },
      {
        id: uuidv4(),
        name: "Edit Profile",
        path: "/profile/user_avatar",
      },
      {
        id: uuidv4(),
        name: "About",
        path: "/about",
      },
      {
        id: uuidv4(),
        name: "Contact",
        path: "/contact",
      },
      {
        id: uuidv4(),
        name: "Wallet",
        path: "/wallet",
      },
      {
        id: uuidv4(),
        name: "Login",
        path: "/login",
      },
      {
        id: uuidv4(),
        name: "Page 404",
        path: "/404",
      },
      {
        id: uuidv4(),
        name: "Terms of Service",
        path: "/tarms",
      },
    ],
  };
  const collections = {
    id: 4,
    name: "Create",
    pages: [
      {
        id: uuidv4(),
        name: t('create_collection'),
        path: "/collection/create",
      },
      {
        id: uuidv4(),
        name: t('create_nft'),
        path: "/create",
      },
    ],
  };
  const explore = {
    id: 3,
    name: "Explore",
    pages: [
      {
        id: uuidv4(),
        name: t('all_nfts'),
        path: "/nft",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={24}
            height={24}
            className="h-4 w-4 fill-jacarta-700"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
          </svg>
        ),
      },
      {
        id: uuidv4(),
        name: t('all_collections'),
        path: "/collection/explore_collection",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={24}
            height={24}
            className="h-4 w-4 fill-jacarta-700"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
          </svg>
        ),
      },
      // {
      //   id: uuidv4(),
      //   name: "Live Auctions",
      //   path: "/collection/explore_collection",
      //   icon: (
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       viewBox="0 0 24 24"
      //       width={24}
      //       height={24}
      //       className="h-4 w-4 fill-[#428AF8]"
      //     >
      //       <path fill="none" d="M0 0h24v24H0z" />
      //       <path d="M2 6c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6zm2 1v12h16V7H4zm10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM4 2h6v2H4V2z" />
      //     </svg>
      //   ),
      // },
      // {
      //   id: uuidv4(),
      //   name: "Authors",
      //   path: "/art",
      //   icon: (
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       viewBox="0 0 24 24"
      //       width={24}
      //       height={24}
      //       className="h-4 w-4 fill-[#10B981]"
      //     >
      //       <path fill="none" d="M0 0h24v24H0z" />
      //       <path d="M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2zm-1.189 16.111a3.664 3.664 0 0 1 3.667-3.667h1.966A3.558 3.558 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972 3.648 3.648 0 0 1-.513-1.86zM7.5 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
      //     </svg>
      //   ),
      // },
    ],
  };

  const [copied, setCopied] = useState(false);
  const mobileCollapse = (id) => {
    if (isCollapse === id) {
      return setCollapse(null);
    }
    setCollapse(id);
  };

  return (
    <>
      {/* main desktop menu sart*/}
      <header className="js-page-header fixed z-20 w-full backdrop-blur transition-colors">
        <div className="flex items-center px-6 py-6 xl:px-24 ">
          <Link className="shrink-0 relative" href="/">
            <div className="dark:hidden ">
              <Image
                src={"/logo.svg"}
                height={38}
                width={windowSize.width <= 425 ? 130 : 180}
                alt="ArtNXS | NFT Marketplace"
                className="max-h-7 h-auto object-cover"
              />
            </div>
            <div className="hidden dark:block">
              <Image
                src={"/logo.svg"}
                height={38}
                width={windowSize.width <= 425 ? 130 : 180}
                alt="ArtNXS | NFT Marketplace"
                className="max-h-7 h-auto object-cover"
              />
            </div>
            <span class="bg-accent-dark text-white text-[8px] font-bold px-2.5 py-0.5 rounded absolute top-[-3px] left-[-16px] -rotate-45 uppercase">
              Beta
            </span>
          </Link>
          {/* End  logo */}

          <form
            action="search"
            className="relative ml-12 mr-8 hidden basis-3/12 lg:block xl:ml-[8%]"
          >
            <SearchInput placeholder={t('search')} />
            <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="fill-jacarta-500 h-4 w-4 dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
              </svg>
            </span>
          </form>
          {/* End Desktop search form */}

          <div className="js-mobile-menu dark:bg-jacarta-800 invisible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent">
            <nav className="navbar w-full">
              <ul className="flex flex-col lg:flex-row lg:relative lg:bottom-[-3px] gap-1">
                {/* home */}
                <li>
                  <Link href="/">
                    <button
                      className={
                        isChildrenPageActive(route.asPath, "/")
                          ? "bg-accent-dark text-white font-display flex items-center justify-between py-2 text-base rounded-lg lg:px-5"
                          : "text-jacarta-700 font-display flex items-center justify-between py-2 text-base lg:px-5 hover:bg-accent-dark hover:text-white rounded-lg dark:text-white"
                      }
                    >
                      <span>{t('home')}</span>
                    </button>
                  </Link>
                </li>

                {/* collections */}
                {loginDetails?.profile?.id && (
                  <li className="js-nav-dropdown group relative">
                    <button
                      className={
                        isChildrenPageActive(
                          route.asPath,
                          "/collection/create/"
                        ) || isChildrenPageActive(route.asPath, "/create/")
                          ? "dropdown-toggle bg-accent-dark text-white font-display flex items-center justify-between py-2 text-base rounded-lg lg:px-5 w-full"
                          : "dropdown-toggle text-jacarta-700 font-display flex items-center justify-between py-2 text-base lg:px-5 hover:bg-accent-dark rounded-lg dark:text-white w-full hover:text-white "
                      }
                    >
                      <span>{t('create')}</span>

                      <i className="lg:hidden">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width={24}
                          height={24}
                          className="h-4 w-4 dark:fill-white"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                        </svg>
                      </i>
                    </button>

                    <ul
                      className="dropdown-menu dark:bg-black left-0 top-[85%] z-10 hidden min-w-[200px] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 lg:invisible lg:absolute lg:grid lg:translate-y-4 lg:py-4 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative border border-accent-dark"
                      aria-labelledby="navDropdown-4"
                    >
                      {collections?.pages?.map?.((page) => (
                        <li key={page.id}>
                          <Link
                            href={page?.path}
                            className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors"
                          >
                            <span
                              className={`font-display ${
                                isChildrenPageActive(page.path, route.asPath)
                                  ? "text-accent dark:text-accent"
                                  : "text-jacarta-700"
                              } text-sm dark:text-white`}
                            >
                              {page?.name}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                )}
                {/* explore */}
                <li className="js-nav-dropdown nav-item dropdown group relative">
                  <button
                    className={
                      isChildrenPageActive(
                        route.asPath,
                        "/collection/explore_collection/"
                      ) || isChildrenPageActive(route.asPath, "/nft/")
                        ? "dropdown-toggle bg-accent-dark text-white font-display flex items-center justify-between py-2 text-base rounded-lg lg:px-5 w-full"
                        : "dropdown-toggle text-jacarta-700 font-display flex items-center justify-between py-2 text-base lg:px-5 hover:bg-accent-dark rounded-lg dark:text-white w-full hover:text-white "
                    }
                  >
                    <span>{t('explore')}</span>
                    <i className="lg:hidden">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        className="h-4 w-4 dark:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                      </svg>
                    </i>
                  </button>
                  <ul
                    className="dropdown-menu dark:bg-black -left-6 top-[85%] z-10 hidden grid-flow-col grid-rows-2 gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 lg:invisible lg:absolute lg:!grid lg:translate-y-4 lg:py-4 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative border border-accent-dark"
                    aria-labelledby="navDropdown-1"
                  >
                    {explore?.pages?.map((page) => (
                      <li key={page.id}>
                        <Link
                          href={page?.path}
                          className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors"
                        >
                          <span className="font-display text-jacarta-700 text-sm dark:text-white">
                            {page?.name}
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                <li className="group">
                  <Link href="/about">
                    <button
                      className={
                        isChildrenPageActive(route.asPath, "/about/")
                          ? "bg-accent-dark text-white font-display flex items-center justify-between py-2 text-base rounded-lg lg:px-5"
                          : "text-jacarta-700 font-display flex items-center justify-between py-2 text-base lg:px-5 hover:bg-accent-dark rounded-lg dark:text-white hover:text-white"
                      }
                    >
                      <span>{t('about')}</span>
                    </button>
                  </Link>
                </li>
              </ul>
            </nav>
            {/* End menu for desktop */}
            <div className="ml-8 items-center flex xl:ml-12">
              {/* <WalletButton /> */}
              {!WalletDetails?.isLogin && (
                <Link
                  href={"/login"}
                  className="js-wallet border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent-dark flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="512"
                    height="512"
                    viewBox="0 0 512 512"
                    version="1.1"
                    className="h-5 w-5"
                  >
                    <path
                      d=""
                      stroke="none"
                      fill="#080404"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M 67.500 35.656 C 34.416 42.711, 8.473 68.852, 1.458 102.200 C 0.219 108.091, -0 131.223, 0 256.437 L 0 403.744 2.432 413.332 C 10.902 446.719, 38.270 471.691, 72.177 476.971 C 77.517 477.803, 128.513 478.026, 260.500 477.795 C 464.600 477.439, 445.277 478.230, 463.555 469.480 C 486.500 458.496, 503.287 438.166, 509.409 413.947 C 510.654 409.023, 511.971 404.696, 512.336 404.331 C 512.701 403.965, 512.893 336.579, 512.763 254.583 C 512.633 172.587, 512.369 121.475, 512.177 141 C 511.861 173.079, 511.702 175.922, 510.525 170.500 C 508.580 161.537, 503.563 149.321, 498.821 142 C 493.015 133.037, 481.003 121.302, 471.830 115.633 C 464.964 111.389, 451.977 106.061, 444.880 104.576 C 442.717 104.123, 442.145 103.308, 441.601 99.906 C 440.498 93.009, 435.306 80.874, 430 72.791 C 417.500 53.751, 397.546 40.055, 375.792 35.584 C 368.953 34.179, 351.539 34.009, 221.292 34.082 C 95.136 34.152, 73.516 34.373, 67.500 35.656 M 72 70.428 C 54.500 75.455, 41.905 88.091, 36.612 105.932 C 35.132 110.919, 34.428 118, 35.413 118 C 35.640 118, 38.227 116.416, 41.163 114.480 C 46.406 111.022, 57.549 106.265, 66.141 103.817 C 69.500 102.860, 108.965 102.452, 238.167 102.037 L 405.833 101.500 403.167 96.080 C 397.633 84.833, 385.712 74.845, 373.217 70.985 C 366.926 69.042, 363.705 69.001, 221.645 69.067 C 106.120 69.121, 75.582 69.399, 72 70.428 M 0.487 256 C 0.487 338.225, 0.605 371.863, 0.750 330.750 C 0.894 289.638, 0.894 222.363, 0.750 181.250 C 0.605 140.138, 0.487 173.775, 0.487 256 M 72 138.814 C 55.197 143.206, 41.829 156.583, 36.339 174.500 C 34.601 180.170, 34.500 186.573, 34.500 291 L 34.500 401.500 36.832 407.962 C 42.383 423.343, 51.764 433.327, 67 440.067 L 72.500 442.500 252.500 442.807 C 386.434 443.036, 433.908 442.817, 438 441.952 C 454.487 438.469, 469.404 424.803, 475.060 408 C 476.947 402.393, 477.318 398.581, 477.764 380.250 L 478.281 359 425.324 359 C 391.879 359, 370.181 358.604, 366.434 357.924 C 347.052 354.411, 330.590 338.880, 325.489 319.297 C 323.372 311.169, 323.408 270.138, 325.540 261.093 C 329.608 243.834, 342.371 230.143, 360.442 223.652 C 362.458 222.928, 382.928 222.374, 420.500 222.027 L 477.500 221.500 477.435 201 C 477.364 178.373, 476.532 173.607, 470.755 162.719 C 464.739 151.379, 450.394 140.856, 437.201 138.105 C 433.442 137.321, 380.547 137.017, 255.201 137.058 C 92.266 137.111, 77.994 137.248, 72 138.814 M 371 257.167 C 366.952 258.308, 361.635 263.052, 360.012 266.972 C 359.264 268.777, 358.991 276.996, 359.195 291.591 C 359.491 312.879, 359.568 313.595, 361.901 316.867 C 363.222 318.718, 366.147 321.071, 368.401 322.095 C 372.230 323.834, 375.970 323.958, 425.250 323.978 L 478 324 478 290 L 478 256 426.250 256.090 C 395.555 256.144, 373.076 256.582, 371 257.167 M 395 273.722 C 388.910 276.010, 384.044 283.240, 384.044 290 C 384.044 295.449, 387.321 301.523, 391.895 304.549 C 399.614 309.657, 410.668 307.482, 415.710 299.862 C 423.553 288.010, 415.462 272.853, 401.412 273.079 C 398.710 273.122, 395.825 273.412, 395 273.722"
                      stroke="none"
                      fill={theme === "dark" ? "#fff" : "#000"}
                      className="group-hover:fill-white"
                      fill-rule="evenodd"
                    />
                  </svg>
                </Link>
              )}
              {/* End metamask Wallet */}

              {WalletDetails?.isLogin && (
                <div className="js-nav-dropdown group-dropdown relative">
                  <button className="dropdown-toggle border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent-dark ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]">
                    {/*  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width={24}
                      height={24}
                      className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                    </svg> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 512 512"
                      version="1.1"
                      className="h-5 w-5"
                    >
                      <path
                        d=""
                        stroke="none"
                        fill="#080404"
                        fill-rule="evenodd"
                      />
                      <path
                        d="M 225 17.630 C 171.346 24.908, 123.773 48.390, 85.844 86.319 C 18.083 154.080, -2.778 255.505, 32.639 345 C 60.065 414.302, 119.696 467.742, 191.667 487.518 C 215.680 494.116, 226.484 495.464, 255.500 495.483 C 276.142 495.497, 283.767 495.121, 292.500 493.662 C 342.800 485.256, 386.636 463.522, 421.906 429.502 C 443.539 408.635, 458.449 388.204, 471.531 361.500 C 489.093 325.653, 496.804 289.778, 495.712 249 C 494.741 212.755, 487.414 182.919, 471.523 150.500 C 435.056 76.104, 363.964 26.164, 281.500 17.015 C 268.775 15.603, 237.427 15.944, 225 17.630 M 241 49.032 C 151.821 55.657, 77.382 117.913, 54.979 204.606 C 46.519 237.345, 46.539 274.685, 55.035 307.635 C 60.283 327.990, 69.502 349.594, 79.656 365.329 L 84.062 372.159 92.520 364.153 C 120.893 337.295, 159.347 316.494, 198.173 307.001 C 220.669 301.501, 229.393 300.524, 256 300.524 C 282.607 300.524, 291.331 301.501, 313.827 307.001 C 352.653 316.494, 391.107 337.295, 419.480 364.153 L 427.938 372.159 432.559 365.015 C 438.107 356.439, 446.725 338.696, 451.025 327 C 464.975 289.050, 467.162 243.910, 456.965 204.365 C 438.064 131.058, 380.367 73.440, 307.317 54.923 C 287.052 49.785, 261.459 47.512, 241 49.032 M 237.113 81.486 C 200.697 89.720, 174.252 114.166, 163.307 149.712 C 160.804 157.842, 160.601 159.810, 160.601 176 C 160.601 192.190, 160.804 194.158, 163.307 202.288 C 173.431 235.167, 196.872 258.605, 229.712 268.684 C 237.740 271.148, 239.970 271.386, 255.500 271.441 C 270.308 271.492, 273.508 271.208, 280.316 269.235 C 291.805 265.905, 299.487 262.439, 308.785 256.390 C 327.787 244.026, 341.612 225.313, 348.654 202.421 C 351.202 194.138, 351.399 192.249, 351.399 176 C 351.399 159.810, 351.196 157.842, 348.693 149.712 C 338.564 116.818, 314.912 93.157, 282.421 83.416 C 274.858 81.148, 271.217 80.688, 258.500 80.392 C 247.908 80.145, 241.623 80.466, 237.113 81.486 M 218.500 391.959 C 217.400 392.417, 215.150 394.219, 213.500 395.962 C 210.765 398.852, 210.500 399.738, 210.500 406.010 C 210.500 412.504, 210.694 413.089, 213.965 416.464 C 222.112 424.869, 235.181 422.502, 239.443 411.850 C 242.236 404.871, 239.743 397.107, 233.359 392.898 C 230.340 390.908, 222.252 390.397, 218.500 391.959 M 280.445 391.959 C 277.200 393.273, 272.015 399.803, 271.849 402.785 C 271.271 413.199, 275.319 419.255, 284.287 421.393 C 291.261 423.055, 300.005 417.409, 302.014 409.947 C 303.565 404.189, 301.871 399.020, 296.988 394.608 C 293.437 391.400, 292.412 391.007, 287.747 391.063 C 284.861 391.098, 281.575 391.501, 280.445 391.959"
                        stroke="none"
                        fill={theme === "dark" ? "#fff" : "#000"}
                        className="group-hover:fill-white"
                        fill-rule="evenodd"
                      />
                    </svg>
                  </button>
                  <div className="dropdown-menu dark:bg-black border border-jacarta-100 dark:border-accent-dark group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-4 !top-[85%] !left-auto z-10 min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl hidden lg:invisible lg:opacity-0">
                    <div>
                      <Tippy
                        hideOnClick={false}
                        content={
                          copied ? <span>copied</span> : <span>{t('copy')}</span>
                        }
                      >
                        <button className="js-copy-clipboard font-display text-jacarta-700 my-4 flex select-none items-center whitespace-nowrap px-5 leading-none dark:text-white">
                          <span>
                            {WalletDetails?.address?.slice(0, 18)}....
                          </span>
                          <svg
                            onClick={() => {
                              copy(WalletDetails?.address, {
                                debug: true,
                                message: WalletDetails?.address,
                              });
                              setCopied(true);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={24}
                            height={24}
                            className="dark:fill-jacarta-300 fill-jacarta-500 ml-auto mb-px h-4 w-4"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 0 1 2 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z" />
                          </svg>
                        </button>
                      </Tippy>
                    </div>
                    <div className="dark:border-accent-dark/50 border-jacarta-100 mx-5 mb-6 rounded-lg border p-4">
                      <span className="dark:text-jacarta-200 text-sm font-medium tracking-tight">
                        {t('balance')}
                      </span>
                      <div className="flex space-x-2 items-center">
                        <div className="w-4 h-4 relative">
                          <Image
                            src="/polygon.png"
                            fill
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="text-green text-lg font-bold ml-1 inline-block">
                          {parseFloat(WalletDetails?.balance || 0).toFixed(6)}{" "}
                          MATIC
                        </span>
                      </div>
                    </div>
                    <Link
                      href={`/user/${loginDetails?.profile?.id}`}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors"
                    >
                      <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 512 512"
                      version="1.1"
                      className="h-4 w-4"
                    >
                      <path
                        d=""
                        stroke="none"
                        fill="#080404"
                        fill-rule="evenodd"
                      />
                      <path
                        d="M 225 17.630 C 171.346 24.908, 123.773 48.390, 85.844 86.319 C 18.083 154.080, -2.778 255.505, 32.639 345 C 60.065 414.302, 119.696 467.742, 191.667 487.518 C 215.680 494.116, 226.484 495.464, 255.500 495.483 C 276.142 495.497, 283.767 495.121, 292.500 493.662 C 342.800 485.256, 386.636 463.522, 421.906 429.502 C 443.539 408.635, 458.449 388.204, 471.531 361.500 C 489.093 325.653, 496.804 289.778, 495.712 249 C 494.741 212.755, 487.414 182.919, 471.523 150.500 C 435.056 76.104, 363.964 26.164, 281.500 17.015 C 268.775 15.603, 237.427 15.944, 225 17.630 M 241 49.032 C 151.821 55.657, 77.382 117.913, 54.979 204.606 C 46.519 237.345, 46.539 274.685, 55.035 307.635 C 60.283 327.990, 69.502 349.594, 79.656 365.329 L 84.062 372.159 92.520 364.153 C 120.893 337.295, 159.347 316.494, 198.173 307.001 C 220.669 301.501, 229.393 300.524, 256 300.524 C 282.607 300.524, 291.331 301.501, 313.827 307.001 C 352.653 316.494, 391.107 337.295, 419.480 364.153 L 427.938 372.159 432.559 365.015 C 438.107 356.439, 446.725 338.696, 451.025 327 C 464.975 289.050, 467.162 243.910, 456.965 204.365 C 438.064 131.058, 380.367 73.440, 307.317 54.923 C 287.052 49.785, 261.459 47.512, 241 49.032 M 237.113 81.486 C 200.697 89.720, 174.252 114.166, 163.307 149.712 C 160.804 157.842, 160.601 159.810, 160.601 176 C 160.601 192.190, 160.804 194.158, 163.307 202.288 C 173.431 235.167, 196.872 258.605, 229.712 268.684 C 237.740 271.148, 239.970 271.386, 255.500 271.441 C 270.308 271.492, 273.508 271.208, 280.316 269.235 C 291.805 265.905, 299.487 262.439, 308.785 256.390 C 327.787 244.026, 341.612 225.313, 348.654 202.421 C 351.202 194.138, 351.399 192.249, 351.399 176 C 351.399 159.810, 351.196 157.842, 348.693 149.712 C 338.564 116.818, 314.912 93.157, 282.421 83.416 C 274.858 81.148, 271.217 80.688, 258.500 80.392 C 247.908 80.145, 241.623 80.466, 237.113 81.486 M 218.500 391.959 C 217.400 392.417, 215.150 394.219, 213.500 395.962 C 210.765 398.852, 210.500 399.738, 210.500 406.010 C 210.500 412.504, 210.694 413.089, 213.965 416.464 C 222.112 424.869, 235.181 422.502, 239.443 411.850 C 242.236 404.871, 239.743 397.107, 233.359 392.898 C 230.340 390.908, 222.252 390.397, 218.500 391.959 M 280.445 391.959 C 277.200 393.273, 272.015 399.803, 271.849 402.785 C 271.271 413.199, 275.319 419.255, 284.287 421.393 C 291.261 423.055, 300.005 417.409, 302.014 409.947 C 303.565 404.189, 301.871 399.020, 296.988 394.608 C 293.437 391.400, 292.412 391.007, 287.747 391.063 C 284.861 391.098, 281.575 391.501, 280.445 391.959"
                        stroke="none"
                        fill={theme === "dark" ? "#fff" : "#000"}
                        className="group-hover:fill-white"
                        fill-rule="evenodd"
                      />
                    </svg>
                      <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                        {t('my_profile')}
                      </span>
                    </Link>
                    <Link
                      href="/profile/user_avatar"
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.993 3.993 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876 3.993 3.993 0 0 0 20 12c0 1.264.586 2.391 1.502 3.124a10.043 10.043 0 0 1-2.046 3.543 3.993 3.993 0 0 0-3.456.261 3.993 3.993 0 0 0-1.954 2.86 9.99 9.99 0 0 1-4.091.004A3.993 3.993 0 0 0 8 18.927a3.993 3.993 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121 3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124 10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                      </svg>
                      <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                        {t('edit_profile')}
                      </span>
                    </Link>
                    <button
                      onClick={() => disConnectWallet()}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z" />
                      </svg>
                      <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                        {t('sign_out')}
                      </span>
                    </button>
                  </div>
                </div>
              )}
              <DarkMode />
              {/* Language switcher */}
              <div className="js-nav-dropdown group-dropdown relative">
                <button className="dropdown-toggle border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent-dark ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-globe"
                    viewBox="0 0 16 16"
                  >
                    <path
                      className="group-hover:fill-white"
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z"
                    />
                  </svg>
                </button>
                <div className="dropdown-menu dark:bg-black border border-jacarta-100 dark:border-accent-dark group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-4 !top-[85%] !left-auto z-10 min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl hidden lg:invisible lg:opacity-0">
                  <ul>
                    {languages.map((obj) => {
                      return (
                        <li
                          key={obj.key}
                          className={`dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer ${obj.key !== 'fr' && 'mb-1'} ${lang === obj.key ? 'dark:bg-jacarta-600 bg-jacarta-50' : ''}`}
                          onClick={async () => await setLanguage(obj.key)}
                        >
                          <Image src={'/images/locales/'+obj.key+'.png'} width={20} height={20} className="size-2" alt="" />
                          <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                            {obj.language}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>

            {/* End header right content (metamask and other) for desktop */}
          </div>
          {/* header menu conent end for desktop */}
          <div className="ml-auto flex lg:hidden">
            {WalletDetails?.isLogin && (
              <div className="js-nav-dropdown group-dropdown relative">
                <button
                  className="dropdown-toggle border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent-dark ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
                  onClick={() => setMobileToggle(!mobileToggle)}
                >
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 512 512"
                      version="1.1"
                      className="h-5 w-5"
                    >
                      <path
                        d=""
                        stroke="none"
                        fill="#080404"
                        fill-rule="evenodd"
                      />
                      <path
                        d="M 225 17.630 C 171.346 24.908, 123.773 48.390, 85.844 86.319 C 18.083 154.080, -2.778 255.505, 32.639 345 C 60.065 414.302, 119.696 467.742, 191.667 487.518 C 215.680 494.116, 226.484 495.464, 255.500 495.483 C 276.142 495.497, 283.767 495.121, 292.500 493.662 C 342.800 485.256, 386.636 463.522, 421.906 429.502 C 443.539 408.635, 458.449 388.204, 471.531 361.500 C 489.093 325.653, 496.804 289.778, 495.712 249 C 494.741 212.755, 487.414 182.919, 471.523 150.500 C 435.056 76.104, 363.964 26.164, 281.500 17.015 C 268.775 15.603, 237.427 15.944, 225 17.630 M 241 49.032 C 151.821 55.657, 77.382 117.913, 54.979 204.606 C 46.519 237.345, 46.539 274.685, 55.035 307.635 C 60.283 327.990, 69.502 349.594, 79.656 365.329 L 84.062 372.159 92.520 364.153 C 120.893 337.295, 159.347 316.494, 198.173 307.001 C 220.669 301.501, 229.393 300.524, 256 300.524 C 282.607 300.524, 291.331 301.501, 313.827 307.001 C 352.653 316.494, 391.107 337.295, 419.480 364.153 L 427.938 372.159 432.559 365.015 C 438.107 356.439, 446.725 338.696, 451.025 327 C 464.975 289.050, 467.162 243.910, 456.965 204.365 C 438.064 131.058, 380.367 73.440, 307.317 54.923 C 287.052 49.785, 261.459 47.512, 241 49.032 M 237.113 81.486 C 200.697 89.720, 174.252 114.166, 163.307 149.712 C 160.804 157.842, 160.601 159.810, 160.601 176 C 160.601 192.190, 160.804 194.158, 163.307 202.288 C 173.431 235.167, 196.872 258.605, 229.712 268.684 C 237.740 271.148, 239.970 271.386, 255.500 271.441 C 270.308 271.492, 273.508 271.208, 280.316 269.235 C 291.805 265.905, 299.487 262.439, 308.785 256.390 C 327.787 244.026, 341.612 225.313, 348.654 202.421 C 351.202 194.138, 351.399 192.249, 351.399 176 C 351.399 159.810, 351.196 157.842, 348.693 149.712 C 338.564 116.818, 314.912 93.157, 282.421 83.416 C 274.858 81.148, 271.217 80.688, 258.500 80.392 C 247.908 80.145, 241.623 80.466, 237.113 81.486 M 218.500 391.959 C 217.400 392.417, 215.150 394.219, 213.500 395.962 C 210.765 398.852, 210.500 399.738, 210.500 406.010 C 210.500 412.504, 210.694 413.089, 213.965 416.464 C 222.112 424.869, 235.181 422.502, 239.443 411.850 C 242.236 404.871, 239.743 397.107, 233.359 392.898 C 230.340 390.908, 222.252 390.397, 218.500 391.959 M 280.445 391.959 C 277.200 393.273, 272.015 399.803, 271.849 402.785 C 271.271 413.199, 275.319 419.255, 284.287 421.393 C 291.261 423.055, 300.005 417.409, 302.014 409.947 C 303.565 404.189, 301.871 399.020, 296.988 394.608 C 293.437 391.400, 292.412 391.007, 287.747 391.063 C 284.861 391.098, 281.575 391.501, 280.445 391.959"
                        stroke="none"
                        fill={theme === "dark" ? "#fff" : "#000"}
                        className="group-hover:fill-white group-focus:fill-white"
                        fill-rule="evenodd"
                      />
                    </svg>
                </button>
                {mobileToggle && (
                  <div className="dropdown-menu shadow-lg dark:bg-black border border-jacarta-100 dark:border-accent-dark group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-8 !top-full shadow !left-auto z-10 min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl lg:invisible lg:opacity-0">
                    <div>
                      <button className="js-copy-clipboard font-display text-jacarta-700 my-4 flex select-none items-center whitespace-nowrap px-5 leading-none dark:text-white">
                        <span>{WalletDetails?.address?.slice(0, 18)}....</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width={24}
                          height={24}
                          className="dark:fill-jacarta-300 fill-jacarta-500 ml-auto mb-px h-4 w-4"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 0 1 2 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z" />
                        </svg>
                      </button>
                    </div>
                    <div className="dark:border-accent-dark/50 border-jacarta-100 mx-5 mb-6 rounded-lg border p-4">
                      <span className="dark:text-jacarta-200 text-sm font-medium tracking-tight">
                        {t('balance')}
                      </span>
                      <div className="flex space-x-2 items-center">
                        <div className="w-4 h-4 relative">
                          <Image
                            src="/polygon.png"
                            fill
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="text-green text-lg font-bold ml-1 inline-block">
                          {parseFloat(WalletDetails?.balance || 0).toFixed(6)}{" "}
                          MATIC
                        </span>
                      </div>
                    </div>
                    <Link
                      href={`/user/${loginDetails?.profile?.id}`}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 px-5 py-2 transition-colors"
                    >
                      <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 512 512"
                      version="1.1"
                      className="h-4 w-4"
                    >
                      <path
                        d=""
                        stroke="none"
                        fill="#080404"
                        fill-rule="evenodd"
                      />
                      <path
                        d="M 225 17.630 C 171.346 24.908, 123.773 48.390, 85.844 86.319 C 18.083 154.080, -2.778 255.505, 32.639 345 C 60.065 414.302, 119.696 467.742, 191.667 487.518 C 215.680 494.116, 226.484 495.464, 255.500 495.483 C 276.142 495.497, 283.767 495.121, 292.500 493.662 C 342.800 485.256, 386.636 463.522, 421.906 429.502 C 443.539 408.635, 458.449 388.204, 471.531 361.500 C 489.093 325.653, 496.804 289.778, 495.712 249 C 494.741 212.755, 487.414 182.919, 471.523 150.500 C 435.056 76.104, 363.964 26.164, 281.500 17.015 C 268.775 15.603, 237.427 15.944, 225 17.630 M 241 49.032 C 151.821 55.657, 77.382 117.913, 54.979 204.606 C 46.519 237.345, 46.539 274.685, 55.035 307.635 C 60.283 327.990, 69.502 349.594, 79.656 365.329 L 84.062 372.159 92.520 364.153 C 120.893 337.295, 159.347 316.494, 198.173 307.001 C 220.669 301.501, 229.393 300.524, 256 300.524 C 282.607 300.524, 291.331 301.501, 313.827 307.001 C 352.653 316.494, 391.107 337.295, 419.480 364.153 L 427.938 372.159 432.559 365.015 C 438.107 356.439, 446.725 338.696, 451.025 327 C 464.975 289.050, 467.162 243.910, 456.965 204.365 C 438.064 131.058, 380.367 73.440, 307.317 54.923 C 287.052 49.785, 261.459 47.512, 241 49.032 M 237.113 81.486 C 200.697 89.720, 174.252 114.166, 163.307 149.712 C 160.804 157.842, 160.601 159.810, 160.601 176 C 160.601 192.190, 160.804 194.158, 163.307 202.288 C 173.431 235.167, 196.872 258.605, 229.712 268.684 C 237.740 271.148, 239.970 271.386, 255.500 271.441 C 270.308 271.492, 273.508 271.208, 280.316 269.235 C 291.805 265.905, 299.487 262.439, 308.785 256.390 C 327.787 244.026, 341.612 225.313, 348.654 202.421 C 351.202 194.138, 351.399 192.249, 351.399 176 C 351.399 159.810, 351.196 157.842, 348.693 149.712 C 338.564 116.818, 314.912 93.157, 282.421 83.416 C 274.858 81.148, 271.217 80.688, 258.500 80.392 C 247.908 80.145, 241.623 80.466, 237.113 81.486 M 218.500 391.959 C 217.400 392.417, 215.150 394.219, 213.500 395.962 C 210.765 398.852, 210.500 399.738, 210.500 406.010 C 210.500 412.504, 210.694 413.089, 213.965 416.464 C 222.112 424.869, 235.181 422.502, 239.443 411.850 C 242.236 404.871, 239.743 397.107, 233.359 392.898 C 230.340 390.908, 222.252 390.397, 218.500 391.959 M 280.445 391.959 C 277.200 393.273, 272.015 399.803, 271.849 402.785 C 271.271 413.199, 275.319 419.255, 284.287 421.393 C 291.261 423.055, 300.005 417.409, 302.014 409.947 C 303.565 404.189, 301.871 399.020, 296.988 394.608 C 293.437 391.400, 292.412 391.007, 287.747 391.063 C 284.861 391.098, 281.575 391.501, 280.445 391.959"
                        stroke="none"
                        fill={theme === "dark" ? "#fff" : "#000"}
                        className="group-hover:fill-white group-focus:fill-white"
                        fill-rule="evenodd"
                      />
                    </svg>
                      <span
                        className="font-display text-jacarta-700 mt-1 text-sm dark:text-white"
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('my_profile')}
                      </span>
                    </Link>
                    <Link
                      href="/profile/user_avatar"
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 px-5 py-2 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.993 3.993 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876 3.993 3.993 0 0 0 20 12c0 1.264.586 2.391 1.502 3.124a10.043 10.043 0 0 1-2.046 3.543 3.993 3.993 0 0 0-3.456.261 3.993 3.993 0 0 0-1.954 2.86 9.99 9.99 0 0 1-4.091.004A3.993 3.993 0 0 0 8 18.927a3.993 3.993 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121 3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124 10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                      </svg>
                      <span
                        className="font-display text-jacarta-700 mt-1 text-sm dark:text-white"
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('edit_profile')}
                      </span>
                    </Link>
                    <button
                      onClick={() => disConnectWallet()}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 w-full px-5 py-2 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11V8l-5 4 5 4v-3h8v-2H7z" />
                      </svg>
                      <span
                        className="font-display text-jacarta-700 mt-1 text-sm dark:text-white"
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('sign_out')}
                      </span>
                    </button>
                  </div>
                )}
              </div>
            )}
            {!WalletDetails?.isLogin && (
              <Link
                href={"/login"}
                className="js-wallet border-jacarta-100 hover:bg-accent ml-2 focus:bg-accent group dark:hover:bg-accent-dark flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
              >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="512"
                    height="512"
                    viewBox="0 0 512 512"
                    version="1.1"
                    className="h-5 w-5"
                  >
                    <path
                      d=""
                      stroke="none"
                      fill="#080404"
                      fill-rule="evenodd"
                    />
                    <path
                      d="M 67.500 35.656 C 34.416 42.711, 8.473 68.852, 1.458 102.200 C 0.219 108.091, -0 131.223, 0 256.437 L 0 403.744 2.432 413.332 C 10.902 446.719, 38.270 471.691, 72.177 476.971 C 77.517 477.803, 128.513 478.026, 260.500 477.795 C 464.600 477.439, 445.277 478.230, 463.555 469.480 C 486.500 458.496, 503.287 438.166, 509.409 413.947 C 510.654 409.023, 511.971 404.696, 512.336 404.331 C 512.701 403.965, 512.893 336.579, 512.763 254.583 C 512.633 172.587, 512.369 121.475, 512.177 141 C 511.861 173.079, 511.702 175.922, 510.525 170.500 C 508.580 161.537, 503.563 149.321, 498.821 142 C 493.015 133.037, 481.003 121.302, 471.830 115.633 C 464.964 111.389, 451.977 106.061, 444.880 104.576 C 442.717 104.123, 442.145 103.308, 441.601 99.906 C 440.498 93.009, 435.306 80.874, 430 72.791 C 417.500 53.751, 397.546 40.055, 375.792 35.584 C 368.953 34.179, 351.539 34.009, 221.292 34.082 C 95.136 34.152, 73.516 34.373, 67.500 35.656 M 72 70.428 C 54.500 75.455, 41.905 88.091, 36.612 105.932 C 35.132 110.919, 34.428 118, 35.413 118 C 35.640 118, 38.227 116.416, 41.163 114.480 C 46.406 111.022, 57.549 106.265, 66.141 103.817 C 69.500 102.860, 108.965 102.452, 238.167 102.037 L 405.833 101.500 403.167 96.080 C 397.633 84.833, 385.712 74.845, 373.217 70.985 C 366.926 69.042, 363.705 69.001, 221.645 69.067 C 106.120 69.121, 75.582 69.399, 72 70.428 M 0.487 256 C 0.487 338.225, 0.605 371.863, 0.750 330.750 C 0.894 289.638, 0.894 222.363, 0.750 181.250 C 0.605 140.138, 0.487 173.775, 0.487 256 M 72 138.814 C 55.197 143.206, 41.829 156.583, 36.339 174.500 C 34.601 180.170, 34.500 186.573, 34.500 291 L 34.500 401.500 36.832 407.962 C 42.383 423.343, 51.764 433.327, 67 440.067 L 72.500 442.500 252.500 442.807 C 386.434 443.036, 433.908 442.817, 438 441.952 C 454.487 438.469, 469.404 424.803, 475.060 408 C 476.947 402.393, 477.318 398.581, 477.764 380.250 L 478.281 359 425.324 359 C 391.879 359, 370.181 358.604, 366.434 357.924 C 347.052 354.411, 330.590 338.880, 325.489 319.297 C 323.372 311.169, 323.408 270.138, 325.540 261.093 C 329.608 243.834, 342.371 230.143, 360.442 223.652 C 362.458 222.928, 382.928 222.374, 420.500 222.027 L 477.500 221.500 477.435 201 C 477.364 178.373, 476.532 173.607, 470.755 162.719 C 464.739 151.379, 450.394 140.856, 437.201 138.105 C 433.442 137.321, 380.547 137.017, 255.201 137.058 C 92.266 137.111, 77.994 137.248, 72 138.814 M 371 257.167 C 366.952 258.308, 361.635 263.052, 360.012 266.972 C 359.264 268.777, 358.991 276.996, 359.195 291.591 C 359.491 312.879, 359.568 313.595, 361.901 316.867 C 363.222 318.718, 366.147 321.071, 368.401 322.095 C 372.230 323.834, 375.970 323.958, 425.250 323.978 L 478 324 478 290 L 478 256 426.250 256.090 C 395.555 256.144, 373.076 256.582, 371 257.167 M 395 273.722 C 388.910 276.010, 384.044 283.240, 384.044 290 C 384.044 295.449, 387.321 301.523, 391.895 304.549 C 399.614 309.657, 410.668 307.482, 415.710 299.862 C 423.553 288.010, 415.462 272.853, 401.412 273.079 C 398.710 273.122, 395.825 273.412, 395 273.722"
                      stroke="none"
                      fill={theme === "dark" ? "#fff" : "#000"}
                      className="group-hover:fill-white group-focus:fill-white"
                      fill-rule="evenodd"
                    />
                  </svg>
              </Link>
            )}
            <DarkMode />
            <button
              className="js-mobile-toggle border-jacarta-100 hover:bg-accent dark:hover:bg-accent-dark focus:bg-accent group ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
              aria-label="open mobile menu"
              onClick={() => setToggle(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z" />
              </svg>
            </button>
          </div>
          {/* End header right content  for mobile */}
        </div>
        {/* End flex item */}
      </header>
      {/* main desktop menu end */}

      {/* start mobile menu and it's other materials  */}
      <div
        className={`lg:hidden js-mobile-menu dark:bg-black invisible fixed inset-0 z-20 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent ${
          toggle ? "nav-menu--is-open" : "hidden"
        }`}
      >
        <div className="t-0 dark:bg-black fixed left-0 z-10 flex w-full items-center justify-between bg-white p-6 lg:hidden">
          <div className="relative grow">
            <div className="dark:hidden ">
              <Image
                src={"/logo.svg"}
                height={38}
                width={windowSize.width <= 425 ? 130 : 180}
                alt="ArtNXS | NFT Marketplace"
                className="max-h-7 h-auto object-cover"
              />
            </div>
            <div className="hidden dark:block">
              <Image
                src={"/logo.svg"}
                height={38}
                width={windowSize.width <= 425 ? 130 : 180}
                alt="ArtNXS | NFT Marketplace"
                className="max-h-7 h-auto object-cover"
              />
            </div>
            <span class="bg-accent-dark text-white text-[8px] font-bold px-2.5 py-0.5 rounded absolute top-[-3px] left-[-16px] -rotate-45 uppercase">
              Beta
            </span>
          </div>

          {/* Language switcher */}
          <div className="js-nav-dropdown group-dropdown relative">
                <button className="dropdown-toggle border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent-dark ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]" onClick={() => setMobileLangToggle(!mobileLangToggle)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-globe"
                    viewBox="0 0 16 16"
                  >
                    <path
                      className="group-hover:fill-white"
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z"
                    />
                  </svg>
                </button>
                {mobileLangToggle && (<div className="z-60 mt-2 dropdown-menu shadow-lg dark:bg-black border border-jacarta-100 dark:border-accent-dark group-dropdown-hover:opacity-100 group-dropdown-hover:visible !-right-8 !top-full shadow !left-auto min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:shadow-2xl lg:invisible lg:opacity-0">
                  <ul className="p-2">
                    {languages.map((obj) => {
                      return (
                        <li
                          key={obj.key}
                          className={`dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer ${obj.key !== 'fr' && 'mb-1'} ${lang === obj.key ? 'dark:bg-jacarta-600 bg-jacarta-50' : ''}`}
                          onClick={async () => await setLanguage(obj.key)}
                        >
                          <Image src={'/images/locales/'+obj.key+'.png'} width={20} height={20} className="size-2" alt="" />
                          <span className="font-display text-jacarta-700 mt-1 text-sm dark:text-white">
                            {obj.language}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>)}
              </div>

          <button
            className="js-mobile-close border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent-dark ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
            onClick={() => setToggle(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
            </svg>
          </button>
        </div>
        {/* mobile menu top header content */}

        <form action="search" className="relative mt-24 mb-8 w-full hidden">
          {/* <input
          type="search"
          className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-3 px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
          placeholder="Search"
        />
        <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={24}
            height={24}
            className="fill-jacarta-500 h-4 w-4 dark:fill-white"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
          </svg>
        </span> */}
        </form>
        {/* End search form mobile menu  */}

        <nav className="navbar w-full">
          <ul className="flex flex-col lg:flex-row">
            <SearchInput mobile="true" />
            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/">
                <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-white  dark:focus:text-white flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                  <span
                    className={
                      isChildrenPageActive("/", route.asPath)
                        ? "text-accent-dark  dark:text-accent-dark"
                        : ""
                    }
                  >
                    {t('home')}
                  </span>
                </button>
              </Link>
            </li>
            {loginDetails?.profile?.id && (
              <>
                {/* collections */}
                <li className="js-nav-dropdown group relative">
                  <button
                    onClick={() => mobileCollapse(collections.id)}
                    className="dropdown-toggle text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-white dark:focus:text-white flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5 w-full"
                  >
                    <span
                      className={
                        isChildrenPageActive(
                          "/collection/create/",
                          route.asPath
                        ) || isChildrenPageActive("/create/", route.asPath)
                          ? "text-accent-dark  dark:text-accent-dark"
                          : ""
                      }
                    >
                      {t('create')}
                    </span>
                    <i className="lg:hidden">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width={24}
                        height={24}
                        className={
                          isChildrenPageActive(
                            "/collection/create/",
                            route.asPath
                          ) || isChildrenPageActive("/create/", route.asPath)
                            ? "fill-accent-dark  dark:fill-accent-dark"
                            : "dark:fill-white"
                        }
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                      </svg>
                    </i>
                  </button>
                  <ul
                    className={`dropdown-menu left-0 top-[85%] z-10 grid-flow-row grid-cols-[repeat(2,_1fr)] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 dark:bg-black border border-accent-dark lg:invisible lg:absolute lg:!grid lg:translate-y-4 py-5 px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative ${
                      isCollapse === collections.id ? "block" : "hidden"
                    }`}
                    aria-labelledby="navDropdown-4"
                  >
                    {collections?.pages?.map((page) => (
                      <li key={page.id} onClick={() => setToggle(false)}>
                        <Link
                          href={page.path}
                          className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors"
                        >
                          <span
                            className={`font-display text-jacarta-700 text-sm dark:text-white ${
                              isChildrenPageActive(page.path, route.asPath)
                                ? "text-accent dark:text-accent"
                                : ""
                            }`}
                          >
                            {page.name}
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </>
            )}
            <li className="js-nav-dropdown nav-item dropdown group relative">
              <button
                onClick={() => mobileCollapse(explore.id)}
                className="dropdown-toggle text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-white dark:focus:text-white flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5 w-full"
              >
                <span
                  className={
                    isChildrenPageActive("/nft/", route.asPath) ||
                    isChildrenPageActive(
                      "/collection/explore_collection/",
                      route.asPath
                    )
                      ? "text-accent-dark  dark:text-accent-dark"
                      : ""
                  }
                >
                  {t('explore')}
                </span>
                <i className="lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                    className={
                      isChildrenPageActive("/nft/", route.asPath) ||
                      isChildrenPageActive(
                        "/collection/explore_collection/",
                        route.asPath
                      )
                        ? "fill-accent-dark  dark:fill-accent-dark"
                        : "dark:fill-white"
                    }
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                  </svg>
                </i>
              </button>
              <ul
                className={`dropdown-menu left-0 top-[85%] z-10 grid-flow-row grid-cols-[repeat(2,_1fr)] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:visible group-hover:opacity-100 dark:bg-black border border-accent-dark lg:invisible lg:absolute lg:!grid lg:translate-y-4 py-5 px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2 relative ${
                  isCollapse === explore.id ? "block" : "hidden"
                }`}
                aria-labelledby="navDropdown-1"
              >
                {explore?.pages?.map((page) => (
                  <li key={page.id} onClick={() => setToggle(false)}>
                    <Link
                      href={page?.path}
                      className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center rounded-xl px-5 py-2 transition-colors"
                    >
                      <span className="font-display text-jacarta-700 text-sm dark:text-white">
                        {page.name}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            <li className="group" onClick={() => setToggle(false)}>
              <Link href="/about">
                <button className="text-jacarta-700 font-display hover:text-accent focus:text-accent dark:hover:text-white dark:focus:text-white flex items-center justify-between py-3.5 text-base dark:text-white lg:px-5">
                  <span
                    className={
                      isChildrenPageActive("/about/", route.asPath)
                        ? "text-accent-dark  dark:text-accent-dark"
                        : ""
                    }
                  >
                    {t('about')}
                  </span>
                </button>
              </Link>
            </li>
          </ul>
        </nav>
        {/* End navbar mobile menu  */}

        {/* <div className="mt-10 w-full lg:hidden">
        <div className="js-wallet bg-accent shadow-accent-volume hover:bg-accent-dark block w-full rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
          MetaMask not available :
        </div>
        <hr className="dark:bg-jacarta-600 bg-jacarta-100 my-5 h-px border-0" />
        <div className="flex items-center justify-center space-x-5">
          <a className="group">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="facebook"
              className="group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
            </svg>
          </a>
          <a className="group">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="twitter"
              className="group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
            </svg>
          </a>
          <a className="group">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="discord"
              className="group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z" />
            </svg>
          </a>
          <a className="group">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="instagram"
              className="group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
            </svg>
          </a>
          <a className="group">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="tiktok"
              className="group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
            </svg>
          </a>
        </div>
      </div> */}
        {/* mt-10 w-full lg:hidden */}
      </div>
      {/* End mobile menu and it's other materials */}
    </>
  );
}
